import { isEmpty } from 'lodash';
import createReducer from 'legacy/src/shared/util/createReducer';
import { setActiveEducationPeriod } from './actions';
import { TYPES } from './utils';

const groupFiltersFromLocalStorage = JSON.parse(
  window.localStorage.getItem(TYPES.localStorageGroupFilterKey),
);

const initialState = {
  activeEducationPeriod: !isEmpty(groupFiltersFromLocalStorage)
    ? groupFiltersFromLocalStorage.educationPeriod
    : '23',
};

const reducer = createReducer(initialState, {
  [setActiveEducationPeriod]: (state, { payload }) => ({
    ...state,
    activeEducationPeriod: payload,
  }),
});

export default reducer;
